// @ts-nocheck
import { useState, useRef } from 'react';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import MainContainer from '../../ui_components/MainContainer';
import RenderFightInsideBoxComponent from '../Matches/RenderFightInsideBoxComponent';

const GeneralppvContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 95%;
    margin: 0 auto;
    border-radius: 15px;
    overflow: hidden;
    background-color: ${colors.bgColorBlack2};
    color: white;
    padding: 10px;
`

const InfoBasicPpv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;

    & .nameDescriptionPpv {
        font-size: 24px;
        font-weight: 600;
        text-align: center;
        margin: 0;
    }

    & p.description-ppv {
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        line-height: 1;
        margin: 0;
    }
`

const SinglePpvByYearContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;

    & h2.year-ppv {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        margin: 0;
        letter-spacing: 5px;
    }
`

const MainRowContainerPpv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100px;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid white;
`

const LeftPosterPpv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    height: 100%;

    & img.poster-ppv {
        width: 80%;
        height: 80%;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
    }
`

const RightCarouselSomeMatches = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 80%;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    padding: 5px;
    
`

const FightCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: 1px solid white;
    border-radius: 5px;
    color: white;
    background-color: ${colors.bgColorBlack2};
    padding: 5px;
    flex-shrink: 0;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background-color: ${colors.bgColorBordeaux};
        transform: scale(1.05);
    }
    
    & h2 {
        font-size: 12px;
        font-weight: 600;
        text-align: center;
        margin: 0;
        padding: 0;
    }
`


const SinglePpvWithYearsMobile = () => {

    const [ppvDescription, setPpvDescription] = useState(useLoaderData());
    const navigate = useNavigate();

    const navigateToPpv = (ppv) => {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    }
    
    // Array di ref per ogni carousel
    const carouselRefs = useRef([]);

    const scrollCarousel = (carouselIndex, direction) => {
        if (carouselRefs.current[carouselIndex]) {
            const scrollAmount = 130; // Larghezza card + gap
            carouselRefs.current[carouselIndex].scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const renderFightCard = (fight, index) => {
        return (
            <FightCardContainer 
            key={index}
            className='fight-card-container'
            >
                <RenderFightInsideBoxComponent 
                 fight={fight} 
                 withWinner={false}
                />
            </FightCardContainer>
        )
    }

    const renderCarousel = (fights, ppvIndex) => {
        return (
            <RightCarouselSomeMatches 
                ref={el => carouselRefs.current[ppvIndex] = el}
                className='right-carousel-some-matches'
            >
                {fights.map((fight, index) => (
                    renderFightCard(fight, index)
                ))}
            </RightCarouselSomeMatches>
                
        );
    };

    return (
        <MainContainer 
         isMobile={true}
         className='single-ppv-with-years-mobile'
        >
            <InfoBasicPpv className='info-basic-ppv'>

            <h1 className="nameDescriptionPpv"> {ppvDescription.name} </h1>
            <p className='description-ppv'> {ppvDescription.description} </p>

            </InfoBasicPpv>

            <GeneralppvContainer className='general-ppv-container'>
                {ppvDescription.ppvs.map((ppv, index) => (
                    <SinglePpvByYearContainer className='single-ppv-by-year-container' key={index}>
                        <h2 className='year-ppv'> {ppv.date.split('-')[2]} </h2>

                        <MainRowContainerPpv className='main-row-container-ppv' onClick={() => navigateToPpv(ppv)}>
                            <LeftPosterPpv className='left-poster-ppv'>
                                <img src={process.env.REACT_APP_STORAGE_URL + ppv.img_path} alt={ppv.img_path + "_alt"} className='poster-ppv' />
                            </LeftPosterPpv>
                            {renderCarousel(ppv.fights, index)}
                        </MainRowContainerPpv>
                    </SinglePpvByYearContainer>
                ))}
            </GeneralppvContainer>

        </MainContainer>
    );
};

export default SinglePpvWithYearsMobile;